var _g, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgVerificationLogo = function SvgVerificationLogo(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.9825 27.2435C95.5286 15.9103 81.8086 9.11397 70.1882 13.6115C56.9238 18.7452 61.3217 39.8433 49.2736 44.1095C42.7653 46.4141 33.1442 37.8055 26.5688 36.4852C14.4521 34.0528 3.48316 42.6022 0.782151 54.4416C-1.97344 66.5202 2.44622 82.653 15.717 85.9313C31.525 89.8364 39.7593 75.6259 53.0205 71.5455C66.6291 67.3582 81.7604 77.2476 93.0264 65.2152C101.35 56.3258 104.393 38.4657 99.9825 27.2435Z",
    fill: "#E7F1FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M66.7025 9.32178H25.7351C23.4242 9.32178 21.5516 11.1944 21.5516 13.5054V27.209C18.2826 28.1452 15.8892 31.154 15.8892 34.7236C15.8892 38.2932 18.2826 41.302 21.5516 42.2381V93.675C21.5516 95.9859 23.4242 97.8586 25.7351 97.8586H66.7025C69.0134 97.8586 70.8861 95.9859 70.8861 93.675V13.5054C70.8861 11.1942 69.0134 9.32178 66.7025 9.32178Z",
    fill: "#60A0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6671 9.32178V89.4914C75.6671 91.8023 73.7944 93.675 71.4835 93.675H30.5161C28.2052 93.675 26.3325 91.8023 26.3325 89.4914V9.32178C26.3325 7.01084 28.2052 5.13818 30.5161 5.13818H71.4835C73.7944 5.13818 75.6671 7.01084 75.6671 9.32178Z",
    fill: "#B9D5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7315 35.2741C33.7315 39.4498 30.4564 42.8624 26.3325 43.0795V27.4688C30.4564 27.6857 33.7315 31.0985 33.7315 35.2741Z",
    fill: "#60A0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6668 15.9379V9.32105C75.6668 7.01051 73.7937 5.13745 71.4832 5.13745H30.5167C28.2061 5.13745 26.3331 7.01051 26.3331 9.32105V15.9377H75.6668V15.9379Z",
    fill: "#60A0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6673 9.32104V15.9371H71.3084V9.32104C71.3084 7.01011 69.4357 5.13745 67.1248 5.13745H71.4837C73.7946 5.13745 75.6673 7.01011 75.6673 9.32104Z",
    fill: "#B9D5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1136 11.8684C50.7287 11.8684 51.2273 11.3698 51.2273 10.7547C51.2273 10.1397 50.7287 9.64111 50.1136 9.64111C49.4986 9.64111 49 10.1397 49 10.7547C49 11.3698 49.4986 11.8684 50.1136 11.8684Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9134 39.4628C30.2311 39.4628 33.7313 35.9626 33.7313 31.6448C33.7313 27.3271 30.2311 23.8269 25.9134 23.8269C21.5957 23.8269 18.0955 27.3271 18.0955 31.6448C18.0955 35.9626 21.5957 39.4628 25.9134 39.4628Z",
    fill: "#FE8F49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4833 94.6717H61.037C60.487 94.6717 60.041 94.2257 60.041 93.6756C60.041 93.1256 60.487 92.6795 61.037 92.6795H71.4833C73.2408 92.6795 74.6708 91.2495 74.6708 89.492V38.1838C74.6708 37.6338 75.1168 37.1877 75.6669 37.1877C76.2169 37.1877 76.663 37.6338 76.663 38.1838V89.4918C76.663 92.348 74.3395 94.6717 71.4833 94.6717Z",
    fill: "#227EFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4833 4.1416H30.5168C27.6608 4.1416 25.3371 6.46529 25.3371 9.32129V22.852C20.7449 23.1503 17.0994 26.9788 17.0994 31.6451C17.0994 36.3114 20.7449 40.1402 25.3371 40.4383V89.4921C25.3371 92.3481 27.6608 94.6718 30.5168 94.6718H55.4394C55.9895 94.6718 56.4355 94.2257 56.4355 93.6757C56.4355 93.1256 55.9895 92.6796 55.4394 92.6796H30.5168C28.7592 92.6796 27.3293 91.2496 27.3293 89.4921V40.3438C31.5184 39.6643 34.7274 36.0232 34.7274 31.6449C34.7274 27.2667 31.5184 23.6256 27.3293 22.9461V16.9338H74.671V32.5859C74.671 33.1359 75.117 33.5819 75.6671 33.5819C76.2171 33.5819 76.6632 33.1359 76.6632 32.5859V9.32129C76.663 6.46509 74.3395 4.1416 71.4833 4.1416ZM32.7353 31.6451C32.7353 35.4068 29.6751 38.467 25.9134 38.467C22.1518 38.467 19.0916 35.4068 19.0916 31.6451C19.0916 27.8835 22.1518 24.8233 25.9134 24.8233C29.6751 24.8233 32.7353 27.8835 32.7353 31.6451ZM74.6708 14.9416H27.3293V9.32129C27.3293 7.56378 28.7592 6.13379 30.5168 6.13379H71.4835C73.241 6.13379 74.671 7.56378 74.671 9.32129V14.9416H74.6708Z",
    fill: "#227EFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.1724,
    y: 50.1206,
    width: 7.91379,
    height: 7.91378,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.1724,
    y: 61.5515,
    width: 7.91379,
    height: 7.91378,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.1724,
    y: 72.9827,
    width: 7.91379,
    height: 7.9138,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.6034,
    y: 50.1206,
    width: 7.9138,
    height: 7.91378,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.6034,
    y: 61.5515,
    width: 7.9138,
    height: 7.91378,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.6034,
    y: 72.9827,
    width: 7.9138,
    height: 7.9138,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.0345,
    y: 50.1206,
    width: 7.91379,
    height: 7.91378,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.0345,
    y: 61.5515,
    width: 7.91379,
    height: 7.91378,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.0345,
    y: 72.9827,
    width: 7.91379,
    height: 7.9138,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2784 29.3881H56.4613C55.8734 29.3881 55.3965 28.9113 55.3965 28.3233C55.3965 27.7354 55.8734 27.2585 56.4613 27.2585H65.2784C65.8664 27.2585 66.3432 27.7354 66.3432 28.3233C66.3432 28.9113 65.8666 29.3881 65.2784 29.3881Z",
    fill: "#60A0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2785 33.7849H38.8752C38.2872 33.7849 37.8104 33.308 37.8104 32.7201C37.8104 32.1321 38.2872 31.6553 38.8752 31.6553H65.2785C65.8664 31.6553 66.3432 32.1321 66.3432 32.7201C66.3432 33.308 65.8666 33.7849 65.2785 33.7849Z",
    fill: "#60A0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2785 38.1813H38.8752C38.2872 38.1813 37.8104 37.7045 37.8104 37.1166C37.8104 36.5286 38.2872 36.0518 38.8752 36.0518H65.2785C65.8664 36.0518 66.3432 36.5286 66.3432 37.1166C66.3432 37.7045 65.8666 38.1813 65.2785 38.1813Z",
    fill: "#60A0FF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 32,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 32,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 32,
    r: 1,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 102,
    height: 102,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVerificationLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/verificationLogo.77d1098a.svg";
export { ForwardRef as ReactComponent };